import React, { useEffect } from 'react';
import { Grid2 } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import ExpenseTextField from './ExpenseTextField';
import { AmountCurrencyInputAdornment } from './AmountCurrencyInputAdornment';
import { valueAsExpense } from '../../Utils/ValueAsUtils';
import { ExpenseStatusValuesEnum } from './ExpenseStatus.enum';

const AllocatedAmount = (props) => {
    const { disabled, index, expense, isViewOnly, size, isInvoiceReviewLocked = false } = props;
    const { control, errors, watch, clearErrors } = useFormContext();
    const currentStatus = watch(`expenseEntries[${index}].status`);
    const allocatedAmountRequired =
        currentStatus === ExpenseStatusValuesEnum.Approved ||
        currentStatus === ExpenseStatusValuesEnum.InvoiceReview;

    useEffect(() => {
        if (!allocatedAmountRequired) {
            clearErrors(`expenseEntries[${index}].allocatedAmount`);
        }
    }, [allocatedAmountRequired, index, clearErrors]);

    return (
        <Grid2 item size={size || { xs: 12, md: 6 }}>
            <Controller
                control={control}
                name={`expenseEntries[${index}].allocatedAmount`}
                defaultValue={expense?.allocatedAmount ?? ''}
                rules={{
                    required: allocatedAmountRequired ? 'Allocated Amount is required' : false,
                }}
                render={({ onChange, value }) => (
                    <ExpenseTextField
                        required={allocatedAmountRequired}
                        placeholder="0.00"
                        id="allocated-amount"
                        onChange={(e) => onChange(valueAsExpense(e.target.value))}
                        value={value}
                        label="Allocated Amount"
                        endAdornment={
                            <AmountCurrencyInputAdornment
                                disabled={disabled || isViewOnly || isInvoiceReviewLocked}
                                index={index}
                                currencyType={expense?.currency}
                                name={`expenseEntries[${index}].paymentCurrency`}
                            />
                        }
                        error={Boolean(errors.expenseEntries?.[index]?.allocatedAmount)}
                        disabled={isViewOnly || isInvoiceReviewLocked}
                        helperText={errors.expenseEntries?.[index]?.allocatedAmount?.message}
                    />
                )}
            />
        </Grid2>
    );
};

export default AllocatedAmount;
